import React, { useCallback, memo } from 'react';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import {
  ClientCustomCalendarModel,
  ReportCurrency,
  ReportType,
} from '../../../../models';
import * as Styled from '../styled';
import DateRange from '../date-range/DateRange';
import ReportSettingPIT from '../ReportSettingPIT';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';
import SplitByDimensionOrAllocation from '../SplitByDimensionOrAllocation';

interface ReportSettingRollforwardProps {
  onChange: (updatedValue: ReportSettingRollforwardState) => void;
  reportSettingState: ReportSettingRollforwardState;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
  isAllowSplitByAllocationForReport: boolean;
  customCalendarSettings?: ClientCustomCalendarModel;
}

export interface ReportSettingRollforwardState {
  selectedCurrency: SelectOption<ReportCurrency>;
  startDate: string;
  rollforwardThrough: string;
  isValid: boolean;
}

function ReportDateSettingRollforward({
  onChange,
  reportSettingState,
  reportTypeSetting,
  isAllowPIT,
  isAllowSplitByAllocationForReport,
  customCalendarSettings,
}: ReportSettingRollforwardProps): JSX.Element {
  return (
    <>
      <DateRange
        onChange={useCallback(
          (startDate: string, endDate: string, isValid: boolean): void => {
            onChange({
              ...reportSettingState,
              startDate,
              isValid,
              rollforwardThrough: endDate,
            });
          },
          [onChange, reportSettingState],
        )}
        startDate={reportSettingState.startDate}
        endDate={reportSettingState.rollforwardThrough}
        customCalendarSettings={customCalendarSettings}
      />
      <Styled.Line />
      <ReportSettingPIT
        reportType={ReportType.rollforward}
        isAllowPIT={isAllowPIT}
        reportSettingState={reportSettingState}
        reportTypeSetting={reportTypeSetting}
        customCalendarSettings={customCalendarSettings}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingRollforwardState),
          [onChange],
        )}
      />
      <SplitByDimensionOrAllocation
        reportSettingState={reportSettingState}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingRollforwardState),
          [onChange],
        )}
        isAllowSplitByAllocationForReport={isAllowSplitByAllocationForReport}
      />
    </>
  );
}

export default memo(ReportDateSettingRollforward);
